<footer class="ft">
  <div class="container ft__inner">
    <div class="ft__brand">
      <span class="brand__name">MECHTRON</span>
      <span class="brand__sub">WATER SERVICES</span>
      <p class="ft__legal">Mechtron Technical Services Private Limited</p>
    </div>

    <nav class="ft__links" aria-label="Footer">
      <a routerLink="/">Home</a>
      <a routerLink="/equipment">Equipment</a>
      <a routerLink="/about">About</a>
      <a routerLink="/contact-us">Contact</a>
    </nav>

    <ul class="ft__ids">
      <li>GST 27AATCM9449D1ZU</li>
      <li>CIN U71200MH2025PTC458184</li>
    </ul>
  </div>
  <p class="ft__copy">&copy; {{ year }} Mechtron Technical Services Private Limited · Vasai Virar, Maharashtra</p>
</footer>
